import { render, staticRenderFns } from "./CoronaResponseResult.vue?vue&type=template&id=7f81756e&scoped=true"
import script from "./CoronaResponseResult.vue?vue&type=script&lang=js"
export * from "./CoronaResponseResult.vue?vue&type=script&lang=js"
import style0 from "./CoronaResponseResult.vue?vue&type=style&index=0&id=7f81756e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f81756e",
  null
  
)

export default component.exports